require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-alphington-wasnt-even-on-our-radar-meet-yarrabends.json") })
        }
      }, "path---news-alphington-wasnt-even-on-our-radar-meet-yarrabends");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-alphington-wasnt-even-on-our-radar-meet-yarrabends!./.cache/json/news-alphington-wasnt-even-on-our-radar-meet-yarrabends.json
// module id = 786
// module chunks = 231608221292675